import { render, staticRenderFns } from "./messageCard.vue?vue&type=template&id=4c13ff5f&scoped=true&"
import script from "./messageCard.vue?vue&type=script&lang=js&"
export * from "./messageCard.vue?vue&type=script&lang=js&"
import style0 from "./messageCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./messageCard.vue?vue&type=style&index=1&id=4c13ff5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13ff5f",
  null
  
)

export default component.exports